import { put, select } from 'redux-saga/effects';
import { IAppState } from '../../redux';
import { selectIsPublicationAvailable } from '../../selectors/checkoutInfo';
import { publishOffer } from '../../redux/reducers';

export function* autopublish() {
  const state: IAppState = yield select();

  const isPublicationAvailable = selectIsPublicationAvailable(state);

  if (isPublicationAvailable && window.location.search.includes('autopublish')) {
    yield put(publishOffer({ isPremoderationSkip: true }));
  }
}
